import clientConfigurationProvider from "../../../providers/clientConfigurationProvider";
import {
  LOG_LEVEL_ERROR,
  LOG_LEVEL_WARN,
  LOG_LEVEL_INFO
} from "../../constants";

const levels = [LOG_LEVEL_INFO, LOG_LEVEL_WARN, LOG_LEVEL_ERROR];

export default level => {
  const { newRelicLogLevel } = clientConfigurationProvider();
  let newRelicLevelIndex = levels.indexOf(newRelicLogLevel);
  if (newRelicLevelIndex === -1) newRelicLevelIndex = levels.length - 1;

  return levels.indexOf(level) >= newRelicLevelIndex;
};
